import type { Component } from 'vue'

export const icons = import.meta.glob('../assets/icons/*.svg', {
  eager: true,
  import: 'default'
}) as Record<string, Component>

// Transform to array
export const iconList = Object.keys(icons).map(path => {
  const name = path.split('/').pop()?.replace('.svg', '') ?? ''

  return {
    name,
    path
  }
})
